// /** Статусы банка Камкомбанк */
export enum APPLICATION_BANK_STATUS {
  NEW_APPLICATION = "new_application", // Новая заявка
  DIRECTED = "directed", // В работе
  REVISION = "revision", // На доработке
  OFFER = "offer", // Предложение (Формирование предложения) (появляются документы от банка)
  AGREED = "agreed", // на согласовании
  AWAITING_PAYMENT = "awaiting_payment", // Требуется оплата
  PAID = "paid", // Оплачено
  SIGNATURE_REQUIRED = "signature_required", // Требуется подписание (подписание документов от банка)
  AWAITING_SIGNATURE = "awaiting_signature", // Ожидает подписи руководителя
  PROCESSED_BY_LEAD = "processed_by_lead", // в обработке у руководителя
  SIGNED_MANAGER = "signed_manager", // Подписано руководителем
  DEAL_COMPLETED = "deal_completed", // Сделка завершена
}

/** Cтатус заявки в банк */
export type ApplicationBankStatus = {
  id: number;
  bank_id: number;
  bank_name: string;
  type: APPLICATION_BANK_STATUS;
  title: string;
  color: string;
};
